import { render, staticRenderFns } from "./registrationAcknowledgement.vue?vue&type=template&id=3528056a&scoped=true&"
import script from "./registrationAcknowledgement.vue?vue&type=script&lang=js&"
export * from "./registrationAcknowledgement.vue?vue&type=script&lang=js&"
import style0 from "./registrationAcknowledgement.vue?vue&type=style&index=0&id=3528056a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3528056a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VCard,VFlex,VIcon,VLayout,VProgressLinear,VSnackbar,VSwitch})
